import { CreateStatusPageDTO, UpdateStatusPageDTO } from '@meshwatch/types';

import { validate } from '../../shared/validation';
import { ValidationResponse } from '../../shared/validation/types';

import { CREATE_STATUS_PAGE_SCHEMA, UPDATE_STATUS_PAGE_SCHEMA } from './schemas';

export function validateCreateStatusPagePayload(
  payload: CreateStatusPageDTO
): Promise<ValidationResponse<CreateStatusPageDTO>> {
  return validate<CreateStatusPageDTO>(CREATE_STATUS_PAGE_SCHEMA, payload);
}

export function validateUpdateStatusPagePayload(
  payload: UpdateStatusPageDTO
): Promise<ValidationResponse<UpdateStatusPageDTO>> {
  return validate<UpdateStatusPageDTO>(UPDATE_STATUS_PAGE_SCHEMA, payload);
}
